import {
  SET_EMAIL_EDIT_CP, SET_EMAIL_EDIT_NE, SET_EMAIL_EDIT_RNE,
  SET_EMAIL_CLEAR_FORM
} from "../actions/set_email_actions";


const initialState = {
  current_password: '',
  new_email: '',
  re_new_email: ''
};


export const setEmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EMAIL_EDIT_CP: {
      return {
        ...state,
        current_password: action.current_password
      }
    }
    case SET_EMAIL_EDIT_NE: {
      return {
        ...state,
        new_email: action.new_email
      }
    }
    case SET_EMAIL_EDIT_RNE: {
      return {
        ...state,
        re_new_email: action.re_new_email
      }
    }
    case SET_EMAIL_CLEAR_FORM: {
      return {
        ...state,
        current_password: '',
        new_email: '',
        re_new_email: ''
      }
    }
    default:
      return state;
  }
}
